import styled from "styled-components";
import { Colors } from "../../constants/Colors";
import { AppBar, Drawer, ListItem } from "@mui/material";

const HEADER_HEIGHT = "4rem";

export const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
`;

export const HeaderBar = styled(AppBar)`
  background-color: ${Colors.commons.white} !important;
  height: ${HEADER_HEIGHT};
  flex-direction: row !important;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem 0 0;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
`;

export const HeaderLogo = styled.img`
  height: 2.25rem;
  width: auto;
  margin-left: 1rem;
`;

export const UserNameText = styled.p`
  margin: 0;
  font-size: 16px;
  font-weight: bold;
  color: ${Colors.primary[100]} !important;
`;

export const StationText = styled.p`
  margin: 0;
  font-size: 13px;
  color: ${Colors.primary[100]} !important;
`;

export const UserStationContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  margin-right: 1rem;
`;

export const LogoutButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  padding: 0;
  color: ${Colors.secondary["100"]};
  border-radius: 8px;
  transition: background-color 0.2s;
  &:hover {
    background-color: ${Colors.primary[20]};
  }
`;

export const MainWithSidebar = styled.main`
  display: flex;
  flex: 1;
  min-height: 0;
`;

export const Sidebar = styled.aside<{ $expanded: boolean }>`
  width: ${(p) => (p.$expanded ? "240px" : "64px")};
  min-width: ${(p) => (p.$expanded ? "240px" : "64px")};
  background-color: ${Colors.commons.white};
  border-right: 1px solid ${Colors.commons.gray};
  display: flex;
  flex-direction: column;
  transition: width 0.2s ease;
  overflow: hidden;
  flex-shrink: 0;

  @media (max-width: 767px) {
    display: none;
  }
`;

export const SidebarToggle = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 48px;
  padding: 12px;
  border: none;
  background: ${Colors.commons.white};
  color: ${Colors.primary[100]};
  cursor: pointer;
  transition: background-color 0.2s;
  border-bottom: 1px solid ${Colors.commons.gray};
  &:hover {
    background: ${Colors.primary[20]};
  }
`;

export const SidebarList = styled.nav`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(100vh - ${HEADER_HEIGHT} - 48px);
  padding: 8px 0;
`;

export const SidebarListItem = styled(ListItem)`
  color: ${Colors.primary[100]} !important;
  min-height: 48px;
  padding: 0 16px !important;
  display: flex !important;
  align-items: center;
  gap: 16px;
  text-decoration: none;
  border-radius: 0;
  &:hover {
    background-color: ${Colors.primary[20]} !important;
  }
  &.Mui-selected {
    background-color: ${Colors.primary[40]} !important;
  }
  [data-expanded="false"] & {
    justify-content: center;
    padding-left: 12px !important;
    padding-right: 12px !important;
  }
`;

export const MainContent = styled.div`
  flex: 1;
  min-width: 0;
  overflow: auto;
`;

export const MobileDrawer = styled(Drawer)`
  .MuiDrawer-paper {
    width: 240px;
    max-width: 85vw;
    padding-top: 8px;
  }
  @media (min-width: 768px) {
    display: none !important;
  }
`;

export const MobileDrawerList = styled.nav`
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;
  max-height: calc(100vh - 56px);
`;

export const MobileDrawerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 8px 8px 0;
`;

export const MobileDrawerCloseButton = styled.button`
  background: none;
  border: none;
  color: ${Colors.primary[100]};
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background-color: ${Colors.primary[20]};
  }
`;

export const MobileMenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  color: ${Colors.primary[100]};
  cursor: pointer;
  padding: 8px;
  margin-left: 8px;
  border-radius: 8px;
  &:hover {
    background-color: ${Colors.primary[20]};
  }
  @media (max-width: 767px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
